interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export default function LoadingSpinner({ size = 'lg', className = '' }: LoadingSpinnerProps) {
  const sizeClass = size === 'sm' ? 'w-5 h-5' : size === 'md' ? 'w-8 h-8' : 'w-10 h-10'

  return (
    <div className={`flex justify-center py-12 ${className}`}>
      <div className={`${sizeClass} border-3 border-primary/20 border-t-primary rounded-full animate-spin`} />
    </div>
  )
}
